<template>
  <v-container :class="containerClass" fluid>
    <v-row>
      <v-col cols="12">
        <v-data-table
          :headers="headers"
          :items="itemList.data"
          :loading="isLoading"
          :options.sync="options"
          :server-items-length="itemList.meta.total"
          :footer-props="defaultDataTableFooterProps"
          item-key="id"
        >
          <template #top>
            <v-sheet>
              <v-container fluid class="pa-4">
                <v-row align="center">
                  <v-col md="6" cols="12">
                    <h2>User List</h2>
                  </v-col>
                  <v-col md="6" cols="12" class="text-right">
                    <v-btn
                      color="primary"
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      :href="$route('employees.create')"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-plus</v-icon
                      >Tambah
                    </v-btn>
                    <v-btn
                      class="mx-1"
                      :small="$vuetify.breakpoint.mobile"
                      @click="showFilters = !showFilters"
                    >
                      <v-icon :small="$vuetify.breakpoint.mobile" left
                        >mdi-filter</v-icon
                      >{{ showFilters ? 'Hide' : 'Show' }} Filter
                    </v-btn>
                  </v-col>
                </v-row>
              </v-container>
            </v-sheet>
            <v-divider></v-divider>
            <v-expand-transition>
              <v-sheet v-show="showFilters" color="grey lighten-5">
                <v-container fluid class="pa-4">
                  <v-row>
                    <v-col md="3" cols="12">
                      <div class="label mb-2">Name</div>
                      <v-text-field
                        v-model="filters.name"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Name"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col>
                    <!-- <v-col md="3" cols="12">
                      <div class="label mb-2">Role</div>
                      <v-autocomplete
                        v-model="filters.role"
                        :items="roles"
                        item-text="name"
                        item-value="name"
                        outlined
                        solo
                        flat
                        background-color="white"
                        label="Name"
                        hide-details
                        dense
                        clearable
                        @change="getListData"
                        @click:clear="getListData"
                      />
                    </v-col> -->
                    <v-col md="3" cols="12">
                      <div class="label mb-2">Created At</div>
                      <date-picker
                        v-model="filters.created_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                    <v-col md="3" cols="12">
                      <div class="label mb-2">Updated At</div>
                      <date-picker
                        v-model="filters.updated_at"
                        value-type="format"
                        type="datetime"
                        range
                        class="mx-datepicker--dense"
                        confirm
                        @confirm="getListData"
                        @clear="getListData"
                      ></date-picker>
                    </v-col>
                  </v-row>
                </v-container>
                <v-divider></v-divider>
              </v-sheet>
            </v-expand-transition>
          </template>
          <template #[`item.role`]="{ item }">
            {{ item.roles[0].name }}
          </template>
          <template #[`item.created_at`]="{ item }">
            {{ formatDate(item.created_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.updated_at`]="{ item }">
            {{ formatDate(item.updated_at, 'YYYY-MM-DD HH:mm:ss') }}
          </template>
          <template #[`item.action`]="{ item }">
            <div class="text-right">
              <v-btn
                small
                color="secondary"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('employees.detail', item.id)"
              >
                <v-icon small>mdi-eye</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;View</span>
              </v-btn>
              <v-btn
                small
                color="warning"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                :href="$route('employees.update', item.id)"
              >
                <v-icon small>mdi-pencil</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Edit</span>
              </v-btn>
              <v-btn
                small
                color="error"
                class="ma-1"
                :icon="$vuetify.breakpoint.mobile"
                @click="showDeleteDialog(item)"
              >
                <v-icon small>mdi-delete-forever</v-icon>
                <span v-if="!$vuetify.breakpoint.mobile">&nbsp;Delete</span>
              </v-btn>
            </div>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
    <employee-delete-dialog
      v-if="deleteDialog.show"
      v-model="deleteDialog.show"
      :employee="deleteDialog.item"
      @delete="getListData"
    >
    </employee-delete-dialog>
  </v-container>
</template>
<script>
import LayoutDashboard from '@layouts/Dashboard'
import { mapGetters, mapActions, mapMutations } from 'vuex'
import EmployeeDeleteDialog from '@components/Employee/DeleteDialog'
import { ListParams } from '@/models'
import utils from '@/utils'
export default {
  name: 'Employees',
  components: {
    EmployeeDeleteDialog,
  },
  layout: LayoutDashboard,
  data() {
    return {
      headers: [
        { text: 'Name', value: 'name' },
        { text: 'Email', value: 'email', sortable: false },
        { text: 'Role', value: 'role', sortable: false },
        { text: 'Created At', value: 'created_at' },
        { text: 'Updated At', value: 'updated_at' },
        { text: 'Action', value: 'action', sortable: false, align: 'center' },
      ],
      options: {
        page: 1,
        itemsPerPage: 10,
      },
      showFilters: true,
      filters: {
        name: null,
        role: null,
        created_at: [],
        updated_at: [],
      },
      deleteDialog: {
        show: false,
        item: null,
      },
    }
  },
  computed: {
    ...mapGetters({
      itemList: 'employee/list',
      isLoading: 'employee/isListLoading',
      roleList: 'role/list',
      isRoleListLoading: 'role/isListLoading',
      listParams: 'employee/listParams',
    }),
    roles() {
      return this.roleList.data
    },
  },
  watch: {
    options: {
      deep: true,
      handler() {
        this.getListData()
      },
    },
  },
  created() {
    this.init()
  },
  methods: {
    ...mapActions({
      getItemList: 'employee/getList',
      getRoleList: 'role/getList',
    }),
    ...mapMutations({
      setListParams: 'employee/setListParams',
    }),
    init() {
      if (this.listParams) {
        _.merge(this.filters, this.listParams.filters)
        _.merge(this.options, this.listParams.options)
      }
    },
    getListData() {
      const listParams = new ListParams(this.filters, this.options)
      this.getItemList(utils.toServerSideQuery(listParams))
      this.setListParams(listParams)
    },
    showDeleteDialog(item) {
      this.deleteDialog.item = item
      this.deleteDialog.show = true
    },
  },
}
</script>
